// Lo que ve y maneja el profesional desde su panel.
export const MOTIVOS_DE_BLOQUEO = ['almuerzo', 'reunion', 'vacaciones', 'otro'];
export const RECURRENCIAS = ['ninguna', 'diaria', 'semanal'];
// ---------- Pacientes ----------
export const REPUTACIONES = ['sin historial', 'siempre asiste', 'alguna falta', 'falta seguido'];
export const TIPOS_DE_SEGUIMIENTO = ['control_anual', 'limpieza', 'revision', 'otro'];
export const ETIQUETA_DE_SEGUIMIENTO = {
    control_anual: 'Control anual', limpieza: 'Limpieza', revision: 'Revisión', otro: 'Otro control',
};
export const TIPOS_DE_PLANTILLA = ['confirmacion', 'recordatorio', 'recordatorio_2h'];
